import { useController, useFormContext } from 'react-hook-form'

import { TextField } from '@/components/ui/text-field'
import type {
  QuestionnaireFormValues,
  SpecifiableReferralOptions,
} from '@/modules/questionnaire/types'

import { Field } from '../../components/field'

interface Props {
  type: SpecifiableReferralOptions
}

const labels: Record<SpecifiableReferralOptions, string> = {
  socialMedia: 'Social media',
  influencer: 'Influencer',
  blog: 'Blog',
  other: 'Other',
}

export const ReferralSpecifier = ({ type }: Props) => {
  const { control } = useFormContext<QuestionnaireFormValues>()
  const { field } = useController({ control, name: type })

  return (
    <Field
      label={labels[type]}
      isRequired
    >
      <TextField {...field} />
    </Field>
  )
}
